module.exports = __webpack_public_path__ + "files/a2a5aea59ef0cf46e11abf9759d9ebd4.svg";